const API_BASE_URL = process.env.REACT_APP_API_URL;
const LOGIN_ENDPOINT = `${API_BASE_URL}auth/login`; // Endpoint para login

export const loginUser = async (credentials) => {
  try {
    console.log('API_BASE_URL:', API_BASE_URL, 'LOGIN_ENDPOINT:', LOGIN_ENDPOINT);
    const response = await fetch(LOGIN_ENDPOINT, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(credentials),
    });
    const contentType = response.headers.get('content-type') || '';
    let responseData = null;
    if (contentType.includes('application/json')) {
      responseData = await response.json().catch(() => null);
    } else {
      const text = await response.text().catch(() => '');
      responseData = text ? { message: text } : null;
    }

    if (!response.ok) {
      console.error('Error en la petición de login:', response.status, responseData);
      return { success: false, message: (responseData && (responseData.message || responseData.error)) || 'Error al iniciar sesión. Verifique sus credenciales.' };
    }
    
    // Asumiendo que el token principal viene en responseData.token
    if (responseData && responseData.token) {
      localStorage.setItem('authToken', responseData.token); // Almacenar el token principal
      // Podrías querer almacenar más información del usuario si la API la devuelve aquí
      // localStorage.setItem('userData', JSON.stringify(responseData.user)); 
      return { success: true, data: responseData };
    } else {
      console.error('Token no encontrado en la respuesta de login exitoso');
      // Esto sería un caso inesperado si la respuesta es ok pero no hay token
      return { success: false, message: 'Respuesta inesperada del servidor.' }; 
    }

  } catch (error) {
    console.error('Error de conexión o al procesar la solicitud de login:', error);
    return { success: false, message: 'Error de conexión o al procesar la solicitud.' };
  }
}; 